// Initialize immediately if DOM is ready, otherwise wait for DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    initProductRecommendationsSlider();
  });
} else {
  // DOM is already ready
  initProductRecommendationsSlider();
}

// Re-initialize when Shopify section is reloaded
document.addEventListener('shopify:section:load', function(event) {
  const container = event.target.querySelector('.product-recommendations-slider');
  if (container) {
    initProductRecommendationsSlider();
  }
});

  function initProductRecommendationsSlider() {
    const recommendationsSliders = document.querySelectorAll('.product-recommendations-slider');
    
    recommendationsSliders.forEach(function(container) {
      // Initialize Swiper
      const swiper = new Swiper(container.querySelector('.product-recommendations-swiper'), {
        slidesPerView: 1,
        spaceBetween: 10,
        grabCursor: true,
        pagination: {
          el: '.product-recommendations-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: container.querySelector('.product-recommendations-slider__next'),
          prevEl: container.querySelector('.product-recommendations-slider__prev'),
        },
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 2,
            spaceBetween: 10
          },
          // when window width is >= 640px
          640: {
            slidesPerView: 2,
            spaceBetween: 10
          },
          // when window width is >= 1024px
          1024: {
            slidesPerView: 2,
            spaceBetween: 10
          },
          // when window width is >= 1400px
          1400: {
            slidesPerView: 2,
            spaceBetween: 10
          }
        }
      });
      
      // Set up color swatch functionality
      setupColorSwatches(container);
      
      // Set up AJAX add to cart
      setupAjaxAddToCart(container);
    });
  }

  // Set up color swatch functionality
  function setupColorSwatches(container) {
    const colorSwatches = container.querySelectorAll('.product-recommendations-item__color-swatch');
    
    colorSwatches.forEach(swatch => {
      swatch.addEventListener('click', function(e) {
        if (e.currentTarget.classList.contains('is-disabled')) return;
        
        const productId = e.currentTarget.getAttribute('data-product-id');
        const variantId = e.currentTarget.getAttribute('data-variant-id');
        const optionValue = e.currentTarget.getAttribute('data-option-value');
        const variantImage = e.currentTarget.getAttribute('data-variant-image');
        const selector = e.currentTarget.closest('.product-recommendations-item__color-selector');
        
        // Update swatch selection
        selector.querySelectorAll('.product-recommendations-item__color-swatch').forEach(s => {
          s.classList.remove('is-selected');
          const checkmark = s.querySelector('.product-recommendations-item__checkmark');
          if (checkmark) checkmark.remove();
        });
        
        e.currentTarget.classList.add('is-selected');
        if (!e.currentTarget.querySelector('.product-recommendations-item__checkmark')) {
          const checkmark = document.createElement('span');
          checkmark.className = 'product-recommendations-item__checkmark';
          checkmark.innerHTML = `
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12l5 5 9-9" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          `;
          e.currentTarget.appendChild(checkmark);
        }
        
        // Get all variants for this product
        const variantsJSON = document.querySelector(`[data-variants-json="${productId}"]`);
        if (!variantsJSON) return;
        
        const variants = JSON.parse(variantsJSON.textContent);
        const selectedVariant = variants.find(v => v.id.toString() === variantId.toString());
        
        if (!selectedVariant) return;
        
        // Update variant ID in form
        const variantInput = container.querySelector(`[data-variant-id-input="${productId}"]`);
        if (variantInput) {
          variantInput.value = selectedVariant.id;
        }
        
        // Update product image
        const productImage = container.querySelector(`[data-product-featured-image="${productId}"]`);
        if (productImage && variantImage) {
          productImage.src = variantImage;
        }
        
        // Update price
        const priceContainer = container.querySelector(`[data-product-price-container="${productId}"]`);
        if (priceContainer) {
          if (selectedVariant.compare_at_price > selectedVariant.price) {
            priceContainer.innerHTML = `
              <span class="product-recommendations-item__price product-recommendations-item__price--compare igComparePrice" data-variant-id="${selectedVariant.id}">${formatMoney(selectedVariant.compare_at_price)}</span>
              <span class="product-recommendations-item__price product-recommendations-item__price--sale igPrice" data-variant-id="${selectedVariant.id}">${formatMoney(selectedVariant.price)}</span>
            `;
          } else {
            priceContainer.innerHTML = `
              <span class="product-recommendations-item__price igPrice" data-variant-id="${selectedVariant.id}">${formatMoney(selectedVariant.price)}</span>
            `;
          }
        }
        
        // Update add button state
        const addButton = container.querySelector(`[data-product-add-button="${productId}"]`);
        if (addButton) {
          if (selectedVariant.available) {
            addButton.disabled = false;
            addButton.textContent = window.theme?.strings?.addToCart || 'Add to cart';
          } else {
            addButton.disabled = true;
            addButton.textContent = window.theme?.strings?.soldOut || 'Sold out';
          }
        }
      });
    });
  }

  // Set up AJAX add to cart
  function setupAjaxAddToCart(container) {
    const addToCartForms = container.querySelectorAll('.product-recommendations-item__form');
    
    addToCartForms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        const submitButton = form.querySelector('button[type="submit"]');
        
        if (submitButton) {
          submitButton.setAttribute('aria-busy', 'true');
          submitButton.disabled = true;
        }
        
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: new URLSearchParams(new FormData(form))
        })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(function(data) {
          // Dispatch cart:refresh event to update cart
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          
          // Try to open cart drawer if it exists
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.show();
          }
          
          // Reset button state
          if (submitButton) {
            submitButton.removeAttribute('aria-busy');
            submitButton.disabled = false;
          }
        })
        .catch(function(error) {
          console.error('Error adding to cart:', error);
          
          // Reset button state
          if (submitButton) {
            submitButton.removeAttribute('aria-busy');
            submitButton.disabled = false;
          }
          
          // Show error message
          alert('Error adding product to cart. Please try again.');
        });
      });
    });
  }

  // Format money helper function
  function formatMoney(cents) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    
    const value = parseInt(cents || 0, 10);
    
    try {
      // Try to use Shopify's money format if available
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(value);
      }
      
      // Fallback to Intl.NumberFormat
      const locale = document.documentElement.lang || 'en';
      const currency = Shopify?.currency?.active || 'EUR';
      
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
      }).format(value / 100);
    } catch (e) {
      // Final fallback
      return '€' + (value / 100).toFixed(2);
    }
  }